import React from "react"
import Treatment from "../components/tratment/treatment"

import Layout from "../components/layout"
import SEO from "../components/seo"
import image from "../images/semiperm1.jpg"

const description = (
  <div>
    <p>
      MICROBLADING
      <br />
      THE NEWEST DEVELOPMENT IN THE AREA OF PERMANENT MAKE-UP
      <br />
      FOR NATURALLY BEAUTIFUL EYEBROWS
    </p>
    <p>
      Many women dream of perfect eyebrows but unfortunately most have exactly
      the opposite. It is easy to pluck eyebrows incorrectly with the result
      that they are asymmetrical or, in the worst case, have bald spots.
      Microblading offers a new way of eyebrow correction which looks absolutely
      natural. Even extremely thin and irregular brows can be reconstructed with
      this technique.
    </p>
    <p>
      Naturalness should always be priority number one with Semi-Permanent
      Make-up. Thanks to the new Microblading technique drawn eyebrows cannot be
      distinguised from real ones anymore.
    </p>
    <p>
      Microblading offers an alternative method to the established
      Semi-Permanent Make-up technique. With Microblading, eyebrows can be
      created extremely naturally. To achieve this, organic Semi-Permanent
      Make-up colours are being worked into the skin by means of manual blades.
      Extremely fine hairlines are created which show hardly any difference to
      real ones.
    </p>
    <p>
      Depending on drawing technique there will be an individual look for every
      eyebrow. So called HD- and 3D- brow still don’t give away the fact that
      this is Semi-Permanent Make-up. The results appear very natural
      regardsless of the amount of actual natural hair, so let us convince you
      of the perfection of naturalness.
    </p>
  </div>
)

const SemiPerm = () => (
  <Layout>
    <SEO title="Semi permanent make-up" />
    <Treatment
      image={image}
      title="Semi permanent make-up"
      htmlText={description}
    />
  </Layout>
)

export default SemiPerm
